import React from 'react';
import '../styles/Skills.css'; // Ensure you have the CSS file for styling

function Skills() {
  const skillsCategories = {
    frontEnd: ['HTML', 'CSS', 'Bootstrap', 'JavaScript'],
    backEnd: ['Python', 'PHP', 'Java', 'C', 'C++'],
    frameworks: ['React JS', 'React Native', 'Django', 'ExpressJS'],
    servers: ['WAMP', 'XAMPP', 'Hostinger', 'GoDaddy', 'Node.js'],
    cloud: ['AWS (Amazon Web Services)', 'GitLab', 'GitHub'],
    operatingSystems: ['Windows', 'Linux', 'Mac'],
    ides: ['Eclipse', 'NetBeans', 'PyCharm', 'Sublime', 'VS Code', 'Android Studio']
  };

  return (
    <div className="skills-section">
      <h2>Skills</h2>
      {Object.entries(skillsCategories).map(([category, skills]) => (
        <div key={category} className="skill-category">
          <h3>{category.replace(/([A-Z])/g, ' $1').trim()}</h3>
          <ul className="skill-list">
            {skills.map(skill => (
              <li key={skill} className="skill-item">{skill}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default Skills;
